import { IMap } from "./IMap";

class ApplicationStrings implements IMap<string> {
    public locale: string;
    [index: string]: string;

    constructor(locale: string, stringDictionary: { [index: string]: string }) {
        Object.assign(this, { locale, ...stringDictionary });
    }
}

export { ApplicationStrings };
